<template>
  <div class="shop-property">
    <div class="content-header">
      <div class="left">店铺资产</div>
      <div class="right"></div>
      <div class="bottom"></div>
    </div>

    <Alert type="warning" style="font-size: 12px"
      ><Icon
        type="ios-alert-outline"
        size="14"
        style="margin-right: 10px"
      />店铺资产仅包含支付方式为“微信支付”的订单所产生的结算金额</Alert
    >
    <div class="pageTitle">店铺余额</div>
    <div class="shop-balance">
      <div class="left">
        <div>
          <span class="tit">店铺可用余额(元)</span>
          <Icon type="ios-alert-outline" size="14" style="margin-left: 5px" />
          <router-link :to="{name:'finance_billing'}">
            <span class="log">资金对账</span>
          </router-link>
          <!-- <router-link to="/finance/wechat-balance/balance-log">
            <span class="log">提现记录</span>
          </router-link> -->
        </div>
        <div class="bottom">
          <span class="money">{{ (balance.available_amount / 100).toFixed(2) }}</span>
          <Button class="btn" type="primary">充值</Button>
          <Button
            class="btn"
            style="color: #4788f7"
            :to="{ name: 'wechat_withdraw' }"
            >提现</Button
          >
        </div>
      </div>
      <div class="item">
        <div>
          <span class="tit">待结算(元)</span>
          <Icon type="ios-alert-outline" size="14" style="margin-left: 5px" />
          <span class="log">明细</span>
        </div>
        <div class="bottom">
          <span class="money">0.00</span>
        </div>
      </div>
      <div class="item">
        <div>
          <span class="tit">冻结金额(元)</span>
          <Icon type="ios-alert-outline" size="14" style="margin-left: 5px" />
          <span class="log">明细</span>
        </div>
        <div class="bottom">
          <span class="money">{{(balance.pending_amount / 100).toFixed(2)}}</span>
        </div>
      </div>
    </div>

    <div class="pageTitle pageTT">交易记录</div>
    <div class="deal-log">
      <div class="filter-box">
        <div>
          时间区间：
          <DatePicker
            type="daterange"
            v-model="page.date"
            placeholder="选择筛选日期"
            style="width: 300px"
          ></DatePicker>
          <span style="margin-left: 30px">最近：</span>
          <RadioGroup
            type="button"
            v-model="radio"
            @on-change="onChangeSelectData"
          >
            <Radio label="1">
              <span>一周</span>
            </Radio>
            <Radio label="2">
              <span>一个月</span>
            </Radio>
            <Radio label="3">
              <span>三个月</span>
            </Radio>
          </RadioGroup>
        </div>
        <div class="bottom">
          <span class="btn-filter" @click="getData">筛选</span>
          <span class="btn" @click="reset">清空</span>
          <span class="btn">导出报表</span>
        </div>
      </div>
      <div class="bottom_left filter-status">
        <p class="tag_p">
          <span
            class="tag"
            @click="selectStatus('')"
            :class="{ active: page.status === '' }"
            >全部</span
          >
          <span
            class="tag"
            @click="selectStatus(0)"
            :class="{ active: page.status === 0 }"
            >待支付</span
          >
          <span
            class="tag"
            @click="selectStatus(1)"
            :class="{ active: page.status === 1 }"
            >待结算</span
          >
          <span
            class="tag"
            @click="selectStatus(2)"
            :class="{ active: page.status === 2 }"
            >已结算</span
          >
          <span
            class="tag"
            @click="selectStatus(12)"
            :class="{ active: page.status === 12 }"
            >交易冻结</span
          >
          <span
            class="tag"
            @click="selectStatus('-1')"
            :class="{ active: page.status === '-1' }"
            >交易取消</span
          >
        </p>
      </div>
      <Table
        size="large"
        stripe
        :columns="columns"
        :data="data"
        :span-method="handleSpan"
      >
        <template slot-scope="{ row }" slot="action"> </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { timeForMat } from "@/libs/tools";
export default {
  data() {
    return {
      modal: {
        status: false,
        title: "",
        data: {
          type: 1,
          month: 12,
          pay_type: 0,
          eduction: 0,
          money: 0,
          oldMoney: 0,
          coupon: 0,
          pay_params: {
            img: [],
          },
          monthNumber: 0,
        },
      },
      balance: {
        available_amount: 0,
        pending_amount: 0,
        sub_mchid: "",
      },
      loading: false,
      radio: "",
      page: {
        p: 0,
        l: 10,
        data: "",
        status: "",
      },
      payModalStatus: false,
      data: [],
      columns: [
        {
          key: "title",
          title: "订单时间",
          slot: "title",
        },
        {
          key: "versions1",
          slot: "versions1",
          title: "订单号|收款单号",
        },
        {
          key: "versions2",
          slot: "versions2",
          title: "订单金额(元)",
        },
        {
          key: "versions2",
          slot: "versions2",
          title: "支付方式",
        },
        {
          key: "versions3",
          slot: "versions3",
          title: "状态",
        },
        {
          key: "action",
          slot: "action",
          title: "操作",
        },
      ],
    };
  },
  mounted() {
    this.getBalance();
    this.getData();
  },
  methods: {
    ...mapActions(["GetWechatBalance", "SubmitWithdrawal"]),
    reset() {
      this.radio = "";
      this.page = {
        l: 10,
        p: 0,
        date: "",
        status: "",
      };
    },
    getData() {},
    getBalance() {
      this.GetWechatBalance().then((res) => {
        if (res.status) this.balance = res.data;
      });
    },

    onChangeSelectData(e) {
      switch (e) {
        case "1":
          let dates1 = timeForMat(7);
          this.page.date = [dates1.t1, dates1.t2];
          break;
        case "2":
          let dates = timeForMat(30);
          this.page.date = [dates.t1, dates.t2];
          break;
        case "3":
          let dates2 = timeForMat(90);
          this.page.date = [dates2.t1, dates2.t2];
          break;
      }
    },
    selectStatus(status) {
      this.page.status = status;
      // this.getData();
    },
  },
  computed: mapGetters({
    shop_agent: "shop_agent",
    current_user: "current_user",
  }),
  watch: {},
};
</script>
<style lang='less' >
@import "./index.less";
</style>
